import React, { useEffect, useState } from 'react'
import { ILoadLight } from '../../types/load';
import { NavLink } from 'react-router-dom';
import moment from 'moment';
import { Button } from '@mui/material';

import { UtilityService } from '../../services/utilityService';

import { Icons } from '../icons';

export interface ILoadTableProps {
	data?: ILoadLight[];
	customer?: string;
	vendor?: string;
	trailer?: string;
	hwiNumber?: string;
	status?: string;
}

const LoadTable: React.FunctionComponent<ILoadTableProps> = ({ data, customer, vendor, trailer, hwiNumber, status }) => {
	const [dataView, setDataView] = useState<ILoadLight[]>([]);
	const [firstVisibleRow, setFirstVisibleRow] = useState(0);
	const [lastVisibleRow, setLastVisibleRow] = useState(9);
	const [pageSize, setPageSize] = useState(10);
	const [sortField, setSortField] = useState("name");
	const [sortAscending, setSortAscending] = useState(true);

	useEffect(() => {
		if (data) {
			let newData = data.filter((item) => {
				if (customer && customer != "All" && item.customerName != customer) {
					return false;
				}
				if (vendor && vendor != "All" && item.vendorName != vendor) {
					return false;
				}
				if (trailer && trailer != "" && item.trailerNumber.toLowerCase().indexOf(trailer.toLowerCase()) < 0) {
					return false;
				}
				if (hwiNumber && hwiNumber != "" && item.hwiNumber.toLowerCase().indexOf(hwiNumber.toLowerCase()) < 0) {
					return false;
				}
				if (status && status != "All" && item.status != status) {
					return false;
				}
				return true;
			}).slice();

			if (sortField) {
				switch (sortField) {
					case "trailer": {
						newData.sort((a, b) => UtilityService.compareStrings(a.trailerNumber, b.trailerNumber));
						break;
					}
					case "customer": {
						newData.sort((a, b) => UtilityService.compareStrings(a.customerName, b.customerName));
						break;
					}
					case "vendor": {
						newData.sort((a, b) => UtilityService.compareStrings(a.vendorName, b.vendorName));
						break;
					}
					case "plantweight": {
						newData.sort((a, b) => UtilityService.compareNumbers(a.plantWeight, b.plantWeight));
						break;
					}
					case "requestdate": {
						newData.sort((a, b) => UtilityService.compareStrings(a.scheduledPickupDate?.toString(), b.scheduledPickupDate?.toString()));
						break;
					}
					case "status": {
						newData.sort((a, b) => UtilityService.compareStrings(a.status, b.status));
						break;
					}
					default: {
						newData.sort((a, b) => UtilityService.compareStrings(a.hwiNumber, b.hwiNumber));
						break;
					}
				}
			}
			if (!sortAscending) newData.reverse();

			setDataView(newData);
		}
	}, [data, customer, vendor, trailer, hwiNumber, status, sortField, sortAscending])

	const handleHeaderClick = (field: string) => {
		if (sortField == field) {
			setSortAscending(!sortAscending);
		}
		else {
			setSortAscending(true);
			setSortField(field);
		}
	}

	const handlePageBack = () => {
		setFirstVisibleRow(firstVisibleRow - pageSize);
		setLastVisibleRow(lastVisibleRow - pageSize);
	}

	const handlePageForward = () => {
		setFirstVisibleRow(firstVisibleRow + pageSize);
		setLastVisibleRow(lastVisibleRow + pageSize);
	}

	return (
		<div className="hwi-entity-search-results-table">
			<div className="headers">
				<div className="col-bol">
					<p onClick={() => handleHeaderClick("bol")}>
						BOL #
						{" "}
						{(sortField == "bol" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "bol" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-trailer">
					<p onClick={() => handleHeaderClick("trailer")}>
						Trailer #
						{" "}
						{(sortField == "trailer" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "trailer" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-customer">
					<p onClick={() => handleHeaderClick("customer")}>
						Customer
						{" "}
						{(sortField == "customer" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "customer" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-vendor">
					<p onClick={() => handleHeaderClick("vendor")}>
						Vendor
						{" "}
						{(sortField == "vendor" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "vendor" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-plant-weight">
					<p onClick={() => handleHeaderClick("plantweight")}>
						Material Wt
						{" "}
						{(sortField == "plantweight" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "plantweight" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				{/* <div className="col-vendor-weight">
					<p onClick={() => handleHeaderClick("vendorweight")}>
						Vendor Wt
						{" "}
						{(sortField == "vendorweight" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "vendorweight" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div> */}
				<div className="col-pickup">
					<p onClick={() => handleHeaderClick("pickupdate")}>
						Status
						{" "}
						{(sortField == "pickupdate" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "pickupdate" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-request">
					<p onClick={() => handleHeaderClick("requestdate")}>
						Scheduled
						{" "}
						{(sortField == "requestdate" && sortAscending) && <Icons.SortAscAlpha height="16px"></Icons.SortAscAlpha>}
						{(sortField == "requestdate" && !sortAscending) && <Icons.SortDescAlpha height="16px"></Icons.SortDescAlpha>}
					</p>
				</div>
				<div className="col-controls">{""}</div>
			</div>
			<div className="data">
				{dataView?.length > 0 ?
					(
						dataView?.map((item, index) => (
							<div className={index >= firstVisibleRow && index <= lastVisibleRow ? "row" : "row row-hidden"} key={item.id}>
								<div className="col-bol"><p>{item.hwiNumber}</p></div>
								<div className="col-trailer"><p>{item.trailerNumber}</p></div>
								<div className="col-customer"><p>{item.customerName}</p></div>
								<div className="col-vendor"><p>{item.vendorName}</p></div>
								<div className="col-plant-weight"><p>{item.plantWeight.toLocaleString()}</p></div>
								{/* <div className="col-vendor-weight"><p>???</p></div> */}
								<div className="col-pickup"><p>{item.status}</p></div>
								<div className="col-request"><p>{item.scheduledPickupDate ? moment(item.scheduledPickupDate).format("MM/DD/yyyy") : ""}</p></div>
								<div className="col-controls">
									<p>
										<NavLink to={"/tils/" + item.id}>
											<Icons.ViewItem fill="#272f50" height="14px"></Icons.ViewItem>
											{" "}
											Open
										</NavLink>
									</p>
								</div>
							</div>
						))
					) :
					(
						<div className="no-results">0 results</div>
					)
				}
			</div>
			<div className="pager">
					<div className="pager-button"><Button variant="outlined"fullWidth={true} disabled={firstVisibleRow == 0 ? true : false} onClick={handlePageBack}>Previous</Button></div>
					<div className="pager-text">{`${firstVisibleRow + 1} to ${(lastVisibleRow + 1) <= dataView.length ? lastVisibleRow + 1 : dataView.length} of ${dataView.length}`}</div>
					<div className="pager-button"><Button variant="outlined" fullWidth={true} disabled={lastVisibleRow >= dataView.length - 1 ? true : false} onClick={handlePageForward}>Next</Button></div>
				</div>
		</div>
	)
}

export default LoadTable;